export default "__VITE_ASSET__722fb007__$_?component__"